import { Button } from 'antd';
import styled from 'styled-components';

export const StyledIconBtn = styled(Button)`
  && {
    width: 24px !important;
    min-width: 24px !important;
    height: 24px;
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  &&:hover,
  &&:focus,
  &&:active,
  &&:focus-visible,
  &&:focus-within,
  &&.ant-btn-loading {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }

  &&:disabled,
  &&[disabled] {
    opacity: 0.5;
    cursor: not-allowed !important;
    border: none !important;
    background-color: transparent !important;
  }

  &&:disabled:hover,
  &&[disabled]:hover,
  &&:disabled:focus,
  &&[disabled]:focus,
  &&:disabled:active,
  &&[disabled]:active {
    cursor: not-allowed !important;
    opacity: 0.5;
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }

  &&::before,
  &&::after {
    display: none !important;
  }

  .ant-click-animating,
  .ant-wave {
    display: none !important;
  }

  img {
    width: 16px !important;
    height: 16px !important;
  }

  svg {
    display: block;
    font-size: 16px;
  }
`;
